import { makeStyles, Theme } from "@material-ui/core";

const customPaperStyles = makeStyles(
  (theme: Theme) => ({
    customPaper: {
      borderRadius: "13px",
    },
    customPaperMobile: {
      border: "none",
    },
    disable: {
      backgroundColor: "#BABABA;",
      pointerEvents: "none",
    },
  }),
  { index: 1 }
);

export default customPaperStyles;
